import { useContext, useEffect } from "react";
import { LocationConfigurationContext } from "./LocationConfigurationProvider";

function ThemeProvider() {
  const { theme } = useContext(LocationConfigurationContext);

  useEffect(() => {
    Object.entries(theme).map(([key, value]) =>
      document.body.style.setProperty(key, value)
    );
  }, [theme]);

  return null;
}

export { ThemeProvider };
